import { Trans } from '@lingui/macro'

import * as React from 'react'

import { Text } from '~ui/components/typography/Text/Text'

type TProps = NoChildren

/**
 * Validation message text of the OrderLockedScreen.
 */
export const OrderLockedMessage: React.FC<TProps> = () => {
  return (
    <Trans>
      Because a payment process was started, we locked the order to{' '}
      <Text as={`span`} fontStyle={`boldSemi`}>
        prevent unexpected price changes.
      </Text>
      You can still select another payment method but it’s not possible to alter the order info or
      content. If you need to do so, you have to create a new order from scratch. We are sorry for
      the inconvenience.
    </Trans>
  )
}
